export default {"src":"/_next/static/media/profile-difficulties.93a29484.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};